<style scoped lang="scss">
  .payment-page {
    flex: 1 0 auto;
    min-height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    @include padding-y(30px);
    background-color: var(--theme-background-color);
    background-repeat: no-repeat;
    background-position: center top;

    @include media(max, sm) {
      @include padding-y(0px);
    }

    .page-wrapper {
      width: 800px;

      @include media(max, md) {
        width: 100%;
      }
    }
  }

  .loading-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;

    .icon {
      position: absolute;
      font-size: 50px;
    }

    .loader {
      position: absolute;
    }
  }

  .page-footer {
    margin-top: 30px;

    @include media(max, md) {
      margin-top: 20px;
    }
  }
</style>

<template>
  <page-layout>
    <transition name="fade-up">
      <div v-show="!loadingState.initial" class="payment-page">
        <div class="page-wrapper">
          <div class="content-block">
            <div class="content-block-body">
              <router-view @load="onPageLoad"/>
            </div>
            <content-block-footer/>
          </div>
        </div>
        <page-footer/>
      </div>
    </transition>
    <div v-if="loadingState.initial" class="loading-container">
      <loader size="xl" system gradient/>
      <icon name="social-donationalerts" system gradient class="animated pulse infinite"/>
    </div>
  </page-layout>
</template>

<script>

import PageLayout from '@layouts/PageLayout'
import ContentBlockFooter from '@components/AppComponents/ContentBlockFooter'
import ContentBlockControls from '@components/AppComponents/ContentBlockControls'
import PaymentForm from '@components/AppComponents/PaymentPage/PaymentForm'
import PageFooter from '@components/AppComponents/PageFooter'

export default {
  name: 'PaymentPage',
  components: {
    PageFooter,
    PaymentForm,
    ContentBlockControls,
    ContentBlockFooter,
    PageLayout,
  },
  methods: {
    onPageLoad() {
      this.loadingState.initial = false
    },
  },
}
</script>
